<template>
  <BlSheetMv :active="isShowChangePhoneNumber" auto-height :is-draggable="false" @close="updateShowModal">
    <div slot="content">
      <BlFlexContainerMv class="p-16" justify-content="space-between" align-items="center">
        <div class="mr-24">
          <BlTextAv variation="subheading-18">Lengkapi no. HP di akun Bukalapak kamu, yuk!</BlTextAv>
          <BlTextAv class="mt-8" variation="body-14">
            Agar lebih mudah saat beli kelas dan bisa dapat info terbaru seputar Prakerja.
          </BlTextAv>
        </div>

        <img :src="$publicUrl('images/img_small_bukalapak_app_phone.png')" alt="change-phone-number" width="64" height="64" />
      </BlFlexContainerMv>
      <BlFlexContainerMv class="ph-16 mb-16" align-items="center" direction="column">
        <BlButtonAv variation="primary" class="mb-12" size="small" fullwidth @click="goToChangePhoneNumberPage">Lengkapi no. HP</BlButtonAv>
        <BlButtonAv variation="outline" size="small" fullwidth @click="updateShowModal(false)">Nanti Saja</BlButtonAv>
      </BlFlexContainerMv>
    </div>
  </BlSheetMv>
</template>

<script>
import {BlButtonAv, BlTextAv, BlFlexContainerMv} from '@bukalapak/bazaar-mweb-latest';
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import prakerjaChangePhoneNumber from 'src/shared/mixins/prakerja-change-phone-number';

export default {
  name: 'PrakerjaChangePhoneNumber',
  components: {
    BlSheetMv,
    BlButtonAv,
    BlTextAv,
    BlFlexContainerMv,
  },
  mixins: [prakerjaChangePhoneNumber],
  data() {
    return {
      isActive: false,
      timeOpened: new Date(Date.now()),
      fragmentIsRendered: false,
      fragmentIsError: false,
    };
  },
};
</script>
